import classNames from 'classnames';
import * as Icons from 'components/Icons';
import React from 'react';
import { Card } from './Card';
import styles from './index.module.scss';

interface Props {
  icon?: React.ReactElement;
  title: string;
  onClick: () => void;
  className?: string;
}
export const IconTitleCard = (props: Props) => {
  const { className, title, ...rest } = props;
  const containerClass = classNames(styles.iconTitleCard, className);
  const icon = props.icon || <Icons.Ellipsis />;
  return (
    <Card className={containerClass} {...rest}>
      {icon}
      <span>{title}</span>
    </Card>
  );
};
